import { COOKIE_NAME_DEALERSHIP_ID, COOKIE_NAME_SALESPERSON_EMAIL } from '@/constants/dealership/dealership.constants';

import { getDealershipName } from './DealershipService';

export const pushFormSubmittedEvent = (
  formid: string,
  formname: string,
  formElement?: HTMLElement | null,
): void => {
  const formData = {} as {
    formClasses?: string;
    formTarget?: string;
  };

  if (formElement) {
    formData.formClasses = formElement.querySelector('form')?.classList.value;
    formData.formTarget = formElement.querySelector('form')?.target;
  }

  (window as any)?.dataLayer?.push({
    event: 'form_submitted',
    'Form ID': formid,
    'Form Text': formname,
    'Form URL': window.location.href,
    'Form Classes': formData.formClasses,
    'Form Target': formData.formTarget,
  });
};

function getCookie(name: string) {
  let matches = document.cookie.match(
    new RegExp(
      '(?:^|; )' +
        name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') +
        '=([^;]*)',
    ),
  );

  return matches ? decodeURIComponent(matches[1] || '') : '';
}

function gtag(..._args: unknown[]) {
  (window as { dataLayer?: unknown[] })?.dataLayer?.push(arguments);
}

export const setDealershipCookieOnUser = async () => {
  // Get the Microsite Dealership cookie value
  const micrositeDealershipId = getCookie(COOKIE_NAME_DEALERSHIP_ID);

  const micrositeDealershipName = micrositeDealershipId
    ? await getDealershipName(micrositeDealershipId)
    : '';

  gtag('set', 'user_properties', {
    microsite_dealership: micrositeDealershipName,
  });
};

export const setSalespersonCookieOnUser = () => {
  const salespersonEmail = getCookie(COOKIE_NAME_SALESPERSON_EMAIL);

  gtag('set', 'user_properties', {
    salesperson: salespersonEmail,
  });
};

export const trackGoogleAdsConversion = (): void => {
  gtag('event', 'conversion', {
    send_to: 'AW-829440814/f9BVCP2C27cZEK6GwYsD',
  });
};
